import {BrowserRouter as Router, Route,Routes} from "react-router-dom";
import Main from "./components/main/main.js"
import Login from "./components/admin/adminLogin.js";
import AdminDashboard from "./components/admin/adminDashboard.js";
import ReactGA from "react-ga";


ReactGA.initialize('UA-273218826-1');
function App() {
  const isAuthenticated=localStorage.getItem("isAuthenticated");
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main></Main>}/>
        <Route path="/admin" element={<Login></Login>}/>
        <Route path="/admin/dashboard" element={isAuthenticated==="true"?<AdminDashboard></AdminDashboard>:<Login></Login>}/>
      </Routes>
    </Router>
  )
}
export default App;
